import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled$1 from 'styled-components';
import { colors } from 'nicollet-tokens';

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  & {\n    display: flex;\n    align-items: center;\n    border: none;\n    background-color: transparent;\n    opacity: 1;\n    transition: opacity 200ms linear;\n\n    /* positioning */\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    padding: 0;\n    margin: 0;\n    width: var(--button-width); /* --button-width is set in filmstrip */\n    z-index: 1;\n  }\n  &[data-direction='forward'] {\n    right: 0;\n    cursor: e-resize;\n    padding-right: 2px;\n  }\n  &[data-direction='back'] {\n    left: 0;\n    cursor: w-resize;\n    padding-left: 2px;\n  }\n\n  /* a11y */\n  &[aria-hidden] {\n    pointer-events: none;\n    opacity: 0;\n  }\n\n  &:focus {\n    outline: ", " dashed 1px;\n    outline-offset: 2px;\n    -moz-outline-radius: 4px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var FilmstripNavButtonElement = styled$1.button(_templateObject(), colors.border.focusOutline);

export { FilmstripNavButtonElement };
